module.exports = __webpack_public_path__ + "img/agent.eb6bb034.png";